import { CategoryResource as Res } from '@shared/resources/category';
import { CategoryCreateUpdateDto as DTO } from '@shared/dto/category';
import { CategoryService } from '@/services/category.service';
import { defineCrudStore } from '@/stores/crud-store';

export const useCategoriesStore = defineCrudStore<DTO, DTO, Res>({
  storeId: 'categories',
  service: new CategoryService(),
});
